import React from 'react'
import './Contact.css'
import withLayout from '../../withLayout'

const Contact = () => (
  <div className='contact'>
    <h2>Contáctanos</h2>
    <p>Búscanos y mándanos mensaje a través de nuestras redes sociales.</p>
    <p><a href='https://www.facebook.com/stadiumtodosjuegan/' target='_blank'>Facebook</a></p>
    <p><a href='https://twitter.com/stadium_app' target='_blank'>Twitter</a></p>
    <p><a href='https://www.instagram.com/stadiumtodosjuegan/' target='_blank'>Instagram</a></p>
    <p>O al correo <a href='mailto:thestadiumapp@gmail.com'>thestadiumapp@gmail.com</a></p>
  </div>
)

export default withLayout(Contact, null)
